import type { DashboardPendingQuoteStatus } from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

/** 미처리 상담 상태 — 견적 목록(`QUOTE_STATUS_LABELS`)과 같은 말을 쓴다. */
export const PENDING_QUOTE_STATUS_LABELS: Readonly<
  Record<DashboardPendingQuoteStatus, { readonly label: string; readonly tone: StatusTone }>
> = {
  REQUESTED: { label: '검토 대기', tone: 'attention' },
  REVISION_REQUESTED: { label: '수정 요청', tone: 'warning' },
};
